import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './initialState';
import { fetchUserPermissions } from './services';

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchUserPermissions.pending, state => {
      state.error = undefined;
      state.loading = true;
    });
    builder.addCase(fetchUserPermissions.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchUserPermissions.fulfilled, (state, action) => {
      state.loading = false;
      state.data = {
        employeeNumber: action.payload.employeeNumber,
        permissions: new Set(action.payload.permissions),
        spaces: new Set(action.payload.spaces),
        adminSpaces: new Set(action.payload.adminOfSpaces),
      };
    });
  },
});

export const { actions: userActions, reducer: userReducer } = userSlice;
